import { TableRow, TableRowProps } from "@mui/material";

type XSubRowProps = TableRowProps & {};
export const XSubRow = ({ ...props }: XSubRowProps) => {
  return (
    <TableRow
      {...props}
      sx={{ ...props.sx, height: "auto", border: "none" }}
    ></TableRow>
  );
};
